import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}

 const DeleteGapAnalysisDocument = gql`
    mutation deleteGapAnalysis($gap_analysis_id: String!) {
  deleteGapAnalysis(gap_analysis_id: $gap_analysis_id) {
    gap_analysis_id
  }
}
    `;
export type DeleteGapAnalysisMutationFn = Apollo.MutationFunction<DeleteGapAnalysisMutation, DeleteGapAnalysisMutationVariables>;
export function useDeleteGapAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGapAnalysisMutation, DeleteGapAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGapAnalysisMutation, DeleteGapAnalysisMutationVariables>(DeleteGapAnalysisDocument, options);
      }
export type DeleteGapAnalysisMutationHookResult = ReturnType<typeof useDeleteGapAnalysisMutation>;
export type DeleteGapAnalysisMutationResult = Apollo.MutationResult<DeleteGapAnalysisMutation>;
export type DeleteGapAnalysisMutationOptions = Apollo.BaseMutationOptions<DeleteGapAnalysisMutation, DeleteGapAnalysisMutationVariables>;
 const GetChargebeePlanSettingsDocument = gql`
    query getChargebeePlanSettings {
  getChargebeePlanSettings {
    id
    chargebee_plan_id
    display_name
    BASE_COST
    DETECTION_COST_PER_TRACK
    DETECTION_TRACKS_INCLUDED
    DETECTION_TRACKS_MAX
    ROYALTY_COST_PER_DOLLAR
    ROYALTY_DOLLARS_INCLUDED
    ROYALTY_DOLLARS_MAX
  }
}
    `;
export function useGetChargebeePlanSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetChargebeePlanSettingsQuery, GetChargebeePlanSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargebeePlanSettingsQuery, GetChargebeePlanSettingsQueryVariables>(GetChargebeePlanSettingsDocument, options);
      }
export function useGetChargebeePlanSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargebeePlanSettingsQuery, GetChargebeePlanSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargebeePlanSettingsQuery, GetChargebeePlanSettingsQueryVariables>(GetChargebeePlanSettingsDocument, options);
        }
export type GetChargebeePlanSettingsQueryHookResult = ReturnType<typeof useGetChargebeePlanSettingsQuery>;
export type GetChargebeePlanSettingsLazyQueryHookResult = ReturnType<typeof useGetChargebeePlanSettingsLazyQuery>;
export type GetChargebeePlanSettingsQueryResult = Apollo.QueryResult<GetChargebeePlanSettingsQuery, GetChargebeePlanSettingsQueryVariables>;
 const GetChargebeeSubscriptionSettingsDocument = gql`
    query getChargebeeSubscriptionSettings($user_id: String) {
  getChargebeeSubscriptionSettings(user_id: $user_id) {
    subscription_active
    subscription_detection_tracks
    subscription_expiration_date
    subscription_plan_type
    subscription_royalty_capacity
  }
}
    `;
export function useGetChargebeeSubscriptionSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetChargebeeSubscriptionSettingsQuery, GetChargebeeSubscriptionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargebeeSubscriptionSettingsQuery, GetChargebeeSubscriptionSettingsQueryVariables>(GetChargebeeSubscriptionSettingsDocument, options);
      }
export function useGetChargebeeSubscriptionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargebeeSubscriptionSettingsQuery, GetChargebeeSubscriptionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargebeeSubscriptionSettingsQuery, GetChargebeeSubscriptionSettingsQueryVariables>(GetChargebeeSubscriptionSettingsDocument, options);
        }
export type GetChargebeeSubscriptionSettingsQueryHookResult = ReturnType<typeof useGetChargebeeSubscriptionSettingsQuery>;
export type GetChargebeeSubscriptionSettingsLazyQueryHookResult = ReturnType<typeof useGetChargebeeSubscriptionSettingsLazyQuery>;
export type GetChargebeeSubscriptionSettingsQueryResult = Apollo.QueryResult<GetChargebeeSubscriptionSettingsQuery, GetChargebeeSubscriptionSettingsQueryVariables>;
 const GetCustomerQrrDocument = gql`
    query getCustomerQrr($user_id: String!) {
  getCustomerQrr(user_id: $user_id)
}
    `;
export function useGetCustomerQrrQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQrrQuery, GetCustomerQrrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQrrQuery, GetCustomerQrrQueryVariables>(GetCustomerQrrDocument, options);
      }
export function useGetCustomerQrrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQrrQuery, GetCustomerQrrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQrrQuery, GetCustomerQrrQueryVariables>(GetCustomerQrrDocument, options);
        }
export type GetCustomerQrrQueryHookResult = ReturnType<typeof useGetCustomerQrrQuery>;
export type GetCustomerQrrLazyQueryHookResult = ReturnType<typeof useGetCustomerQrrLazyQuery>;
export type GetCustomerQrrQueryResult = Apollo.QueryResult<GetCustomerQrrQuery, GetCustomerQrrQueryVariables>;
 const GetCustomerStatementHistoryDocument = gql`
    query getCustomerStatementHistory($user_id: String) {
  getCustomerStatementHistory(user_id: $user_id) {
    data {
      entity {
        id
        name
        role_type
      }
      data {
        period {
          end_date
          start_date
        }
        plays
        earnings
      }
    }
  }
}
    `;
export function useGetCustomerStatementHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerStatementHistoryQuery, GetCustomerStatementHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerStatementHistoryQuery, GetCustomerStatementHistoryQueryVariables>(GetCustomerStatementHistoryDocument, options);
      }
export function useGetCustomerStatementHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerStatementHistoryQuery, GetCustomerStatementHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerStatementHistoryQuery, GetCustomerStatementHistoryQueryVariables>(GetCustomerStatementHistoryDocument, options);
        }
export type GetCustomerStatementHistoryQueryHookResult = ReturnType<typeof useGetCustomerStatementHistoryQuery>;
export type GetCustomerStatementHistoryLazyQueryHookResult = ReturnType<typeof useGetCustomerStatementHistoryLazyQuery>;
export type GetCustomerStatementHistoryQueryResult = Apollo.QueryResult<GetCustomerStatementHistoryQuery, GetCustomerStatementHistoryQueryVariables>;
 const GetDirectoryVersionDocument = gql`
    query getDirectoryVersion($input: String) {
  getDirectoryVersion(input: $input)
}
    `;
export function useGetDirectoryVersionQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectoryVersionQuery, GetDirectoryVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectoryVersionQuery, GetDirectoryVersionQueryVariables>(GetDirectoryVersionDocument, options);
      }
export function useGetDirectoryVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectoryVersionQuery, GetDirectoryVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectoryVersionQuery, GetDirectoryVersionQueryVariables>(GetDirectoryVersionDocument, options);
        }
export type GetDirectoryVersionQueryHookResult = ReturnType<typeof useGetDirectoryVersionQuery>;
export type GetDirectoryVersionLazyQueryHookResult = ReturnType<typeof useGetDirectoryVersionLazyQuery>;
export type GetDirectoryVersionQueryResult = Apollo.QueryResult<GetDirectoryVersionQuery, GetDirectoryVersionQueryVariables>;
 const GetTrqkEntityForNewStatementDocument = gql`
    query getTrqkEntityForNewStatement($id: ID!, $user_id: ID!) {
  getTrqkEntity(id: $id, user_id: $user_id) {
    id
    name
    pro
    role_type
  }
}
    `;
export function useGetTrqkEntityForNewStatementQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkEntityForNewStatementQuery, GetTrqkEntityForNewStatementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkEntityForNewStatementQuery, GetTrqkEntityForNewStatementQueryVariables>(GetTrqkEntityForNewStatementDocument, options);
      }
export function useGetTrqkEntityForNewStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkEntityForNewStatementQuery, GetTrqkEntityForNewStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkEntityForNewStatementQuery, GetTrqkEntityForNewStatementQueryVariables>(GetTrqkEntityForNewStatementDocument, options);
        }
export type GetTrqkEntityForNewStatementQueryHookResult = ReturnType<typeof useGetTrqkEntityForNewStatementQuery>;
export type GetTrqkEntityForNewStatementLazyQueryHookResult = ReturnType<typeof useGetTrqkEntityForNewStatementLazyQuery>;
export type GetTrqkEntityForNewStatementQueryResult = Apollo.QueryResult<GetTrqkEntityForNewStatementQuery, GetTrqkEntityForNewStatementQueryVariables>;
 const GetTrqkEntityTracksDocument = gql`
    query getTrqkEntityTracks($id: ID!, $user_id: ID!) {
  getTrqkEntity(id: $id, user_id: $user_id) {
    id
    name
    role_type
    tracks {
      id
      audio_id
      filename
      detection_status
      earnings
      percent_share
      performance_count
      title
      work_ids
    }
  }
}
    `;
export function useGetTrqkEntityTracksQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkEntityTracksQuery, GetTrqkEntityTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkEntityTracksQuery, GetTrqkEntityTracksQueryVariables>(GetTrqkEntityTracksDocument, options);
      }
export function useGetTrqkEntityTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkEntityTracksQuery, GetTrqkEntityTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkEntityTracksQuery, GetTrqkEntityTracksQueryVariables>(GetTrqkEntityTracksDocument, options);
        }
export type GetTrqkEntityTracksQueryHookResult = ReturnType<typeof useGetTrqkEntityTracksQuery>;
export type GetTrqkEntityTracksLazyQueryHookResult = ReturnType<typeof useGetTrqkEntityTracksLazyQuery>;
export type GetTrqkEntityTracksQueryResult = Apollo.QueryResult<GetTrqkEntityTracksQuery, GetTrqkEntityTracksQueryVariables>;
 const GetTrqkInsightsForUserDocument = gql`
    query getTrqkInsightsForUser($id: ID!, $entity_id: ID) {
  getTrqkInsightsForUser(id: $id, entity_id: $entity_id) {
    id
    timestamp
    top_five_programs_user {
      data {
        show
        earnings
        source
        episode
      }
    }
    bump_falloff_report {
      pro
      region
      newer_statement_period {
        year
        quarter
      }
      older_statement_period {
        year
        quarter
      }
      total_earnings_delta
      total_earnings_percent_delta
      bump {
        title
        earnings_delta
        earnings_percent_delta
      }
      falloff {
        title
        earnings_delta
        earnings_percent_delta
      }
    }
    statement_history {
      data {
        period {
          start_date
          end_date
          unit
        }
        plays
        earnings
      }
    }
    detections_summary {
      data {
        audio_id
        channel
        detection_count
        song_id
        title
      }
      detections_active
    }
    production_company_summary {
      data {
        audio_id
        detection_count
        program_production_company
        title
      }
    }
    publishers_summary {
      data {
        earnings
        name
        performances
      }
      statement_id_end
      statement_id_start
    }
    composers_summary {
      data {
        earnings
        name
        performances
      }
      statement_id_end
      statement_id_start
    }
  }
}
    `;
export function useGetTrqkInsightsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkInsightsForUserQuery, GetTrqkInsightsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkInsightsForUserQuery, GetTrqkInsightsForUserQueryVariables>(GetTrqkInsightsForUserDocument, options);
      }
export function useGetTrqkInsightsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkInsightsForUserQuery, GetTrqkInsightsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkInsightsForUserQuery, GetTrqkInsightsForUserQueryVariables>(GetTrqkInsightsForUserDocument, options);
        }
export type GetTrqkInsightsForUserQueryHookResult = ReturnType<typeof useGetTrqkInsightsForUserQuery>;
export type GetTrqkInsightsForUserLazyQueryHookResult = ReturnType<typeof useGetTrqkInsightsForUserLazyQuery>;
export type GetTrqkInsightsForUserQueryResult = Apollo.QueryResult<GetTrqkInsightsForUserQuery, GetTrqkInsightsForUserQueryVariables>;
 const GetTrqkUserAvatarDocument = gql`
    query getTrqkUserAvatar($id: ID!) {
  getTrqkUser(id: $id) {
    id
    name
    avatar_url
  }
}
    `;
export function useGetTrqkUserAvatarQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkUserAvatarQuery, GetTrqkUserAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkUserAvatarQuery, GetTrqkUserAvatarQueryVariables>(GetTrqkUserAvatarDocument, options);
      }
export function useGetTrqkUserAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkUserAvatarQuery, GetTrqkUserAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkUserAvatarQuery, GetTrqkUserAvatarQueryVariables>(GetTrqkUserAvatarDocument, options);
        }
export type GetTrqkUserAvatarQueryHookResult = ReturnType<typeof useGetTrqkUserAvatarQuery>;
export type GetTrqkUserAvatarLazyQueryHookResult = ReturnType<typeof useGetTrqkUserAvatarLazyQuery>;
export type GetTrqkUserAvatarQueryResult = Apollo.QueryResult<GetTrqkUserAvatarQuery, GetTrqkUserAvatarQueryVariables>;
 const GetTrqkUserCompanyDocument = gql`
    query getTrqkUserCompany($id: ID!) {
  getTrqkUser(id: $id) {
    id
    company
  }
}
    `;
export function useGetTrqkUserCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkUserCompanyQuery, GetTrqkUserCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkUserCompanyQuery, GetTrqkUserCompanyQueryVariables>(GetTrqkUserCompanyDocument, options);
      }
export function useGetTrqkUserCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkUserCompanyQuery, GetTrqkUserCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkUserCompanyQuery, GetTrqkUserCompanyQueryVariables>(GetTrqkUserCompanyDocument, options);
        }
export type GetTrqkUserCompanyQueryHookResult = ReturnType<typeof useGetTrqkUserCompanyQuery>;
export type GetTrqkUserCompanyLazyQueryHookResult = ReturnType<typeof useGetTrqkUserCompanyLazyQuery>;
export type GetTrqkUserCompanyQueryResult = Apollo.QueryResult<GetTrqkUserCompanyQuery, GetTrqkUserCompanyQueryVariables>;
 const GetTrqkUserDetectionNotificationDocument = gql`
    query getTrqkUserDetectionNotification($id: ID!) {
  getTrqkUser(id: $id) {
    id
    detection_notification_enabled
    detection_notification_last
    detection_notification_next
    detection_notification_period
  }
}
    `;
export function useGetTrqkUserDetectionNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkUserDetectionNotificationQuery, GetTrqkUserDetectionNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkUserDetectionNotificationQuery, GetTrqkUserDetectionNotificationQueryVariables>(GetTrqkUserDetectionNotificationDocument, options);
      }
export function useGetTrqkUserDetectionNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkUserDetectionNotificationQuery, GetTrqkUserDetectionNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkUserDetectionNotificationQuery, GetTrqkUserDetectionNotificationQueryVariables>(GetTrqkUserDetectionNotificationDocument, options);
        }
export type GetTrqkUserDetectionNotificationQueryHookResult = ReturnType<typeof useGetTrqkUserDetectionNotificationQuery>;
export type GetTrqkUserDetectionNotificationLazyQueryHookResult = ReturnType<typeof useGetTrqkUserDetectionNotificationLazyQuery>;
export type GetTrqkUserDetectionNotificationQueryResult = Apollo.QueryResult<GetTrqkUserDetectionNotificationQuery, GetTrqkUserDetectionNotificationQueryVariables>;
 const GetTrqkUserInvitationsDocument = gql`
    query getTrqkUserInvitations($id: ID!) {
  getTrqkUser(id: $id) {
    id
    name
    email
    invitations {
      company
      email
      first_name
      last_name
      id
      referrer
    }
  }
}
    `;
export function useGetTrqkUserInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkUserInvitationsQuery, GetTrqkUserInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkUserInvitationsQuery, GetTrqkUserInvitationsQueryVariables>(GetTrqkUserInvitationsDocument, options);
      }
export function useGetTrqkUserInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkUserInvitationsQuery, GetTrqkUserInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkUserInvitationsQuery, GetTrqkUserInvitationsQueryVariables>(GetTrqkUserInvitationsDocument, options);
        }
export type GetTrqkUserInvitationsQueryHookResult = ReturnType<typeof useGetTrqkUserInvitationsQuery>;
export type GetTrqkUserInvitationsLazyQueryHookResult = ReturnType<typeof useGetTrqkUserInvitationsLazyQuery>;
export type GetTrqkUserInvitationsQueryResult = Apollo.QueryResult<GetTrqkUserInvitationsQuery, GetTrqkUserInvitationsQueryVariables>;
 const GetTrqkUserSubscriptionSettingsDocument = gql`
    query getTrqkUserSubscriptionSettings($id: ID!) {
  getTrqkUser(id: $id) {
    id
    subscription_active
    subscription_detection_tracks
    subscription_expiration_date
    subscription_gap_analysis_bmat_sourced
    subscription_gap_analysis_enabled
    subscription_gap_analysis_trqk_sourced
    subscription_id
    subscription_plan_type
    subscription_royalty_capacity
  }
}
    `;
export function useGetTrqkUserSubscriptionSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetTrqkUserSubscriptionSettingsQuery, GetTrqkUserSubscriptionSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrqkUserSubscriptionSettingsQuery, GetTrqkUserSubscriptionSettingsQueryVariables>(GetTrqkUserSubscriptionSettingsDocument, options);
      }
export function useGetTrqkUserSubscriptionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrqkUserSubscriptionSettingsQuery, GetTrqkUserSubscriptionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrqkUserSubscriptionSettingsQuery, GetTrqkUserSubscriptionSettingsQueryVariables>(GetTrqkUserSubscriptionSettingsDocument, options);
        }
export type GetTrqkUserSubscriptionSettingsQueryHookResult = ReturnType<typeof useGetTrqkUserSubscriptionSettingsQuery>;
export type GetTrqkUserSubscriptionSettingsLazyQueryHookResult = ReturnType<typeof useGetTrqkUserSubscriptionSettingsLazyQuery>;
export type GetTrqkUserSubscriptionSettingsQueryResult = Apollo.QueryResult<GetTrqkUserSubscriptionSettingsQuery, GetTrqkUserSubscriptionSettingsQueryVariables>;
 const ListGapAnalysisFiltersDocument = gql`
    query listGapAnalysisFilters($gap_analysis_id: String!, $asset_url: String) {
  listGapAnalysisFilters(gap_analysis_id: $gap_analysis_id, asset_url: $asset_url) {
    filter_input_type
    filter_key
    filter_label
    filter_value_default
    order
  }
}
    `;
export function useListGapAnalysisFiltersQuery(baseOptions: Apollo.QueryHookOptions<ListGapAnalysisFiltersQuery, ListGapAnalysisFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGapAnalysisFiltersQuery, ListGapAnalysisFiltersQueryVariables>(ListGapAnalysisFiltersDocument, options);
      }
export function useListGapAnalysisFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGapAnalysisFiltersQuery, ListGapAnalysisFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGapAnalysisFiltersQuery, ListGapAnalysisFiltersQueryVariables>(ListGapAnalysisFiltersDocument, options);
        }
export type ListGapAnalysisFiltersQueryHookResult = ReturnType<typeof useListGapAnalysisFiltersQuery>;
export type ListGapAnalysisFiltersLazyQueryHookResult = ReturnType<typeof useListGapAnalysisFiltersLazyQuery>;
export type ListGapAnalysisFiltersQueryResult = Apollo.QueryResult<ListGapAnalysisFiltersQuery, ListGapAnalysisFiltersQueryVariables>;
 const ListGapAnalysisPeriodSelectionsDocument = gql`
    query listGapAnalysisPeriodSelections($user_id: String, $entity_id: String) {
  listGapAnalysisPeriodSelections(user_id: $user_id, entity_id: $entity_id) {
    detection_data_end
    detection_data_start
    order
    performance_period_end
    performance_period_label
    performance_period_start
    pro_statement_period_label {
      end_date
      pro
      start_date
      statement_period_label
    }
    pro_statement_present
  }
}
    `;
export function useListGapAnalysisPeriodSelectionsQuery(baseOptions?: Apollo.QueryHookOptions<ListGapAnalysisPeriodSelectionsQuery, ListGapAnalysisPeriodSelectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGapAnalysisPeriodSelectionsQuery, ListGapAnalysisPeriodSelectionsQueryVariables>(ListGapAnalysisPeriodSelectionsDocument, options);
      }
export function useListGapAnalysisPeriodSelectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGapAnalysisPeriodSelectionsQuery, ListGapAnalysisPeriodSelectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGapAnalysisPeriodSelectionsQuery, ListGapAnalysisPeriodSelectionsQueryVariables>(ListGapAnalysisPeriodSelectionsDocument, options);
        }
export type ListGapAnalysisPeriodSelectionsQueryHookResult = ReturnType<typeof useListGapAnalysisPeriodSelectionsQuery>;
export type ListGapAnalysisPeriodSelectionsLazyQueryHookResult = ReturnType<typeof useListGapAnalysisPeriodSelectionsLazyQuery>;
export type ListGapAnalysisPeriodSelectionsQueryResult = Apollo.QueryResult<ListGapAnalysisPeriodSelectionsQuery, ListGapAnalysisPeriodSelectionsQueryVariables>;
 const ListGapAnalysisSummariesDocument = gql`
    query listGapAnalysisSummaries($user_id: String, $entity_id: String) {
  listGapAnalysisSummaries(user_id: $user_id, entity_id: $entity_id) {
    gap_analysis_id
    pro
    description
    performance_period
    channel_count
    date_created
    complete
  }
}
    `;
export function useListGapAnalysisSummariesQuery(baseOptions?: Apollo.QueryHookOptions<ListGapAnalysisSummariesQuery, ListGapAnalysisSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGapAnalysisSummariesQuery, ListGapAnalysisSummariesQueryVariables>(ListGapAnalysisSummariesDocument, options);
      }
export function useListGapAnalysisSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGapAnalysisSummariesQuery, ListGapAnalysisSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGapAnalysisSummariesQuery, ListGapAnalysisSummariesQueryVariables>(ListGapAnalysisSummariesDocument, options);
        }
export type ListGapAnalysisSummariesQueryHookResult = ReturnType<typeof useListGapAnalysisSummariesQuery>;
export type ListGapAnalysisSummariesLazyQueryHookResult = ReturnType<typeof useListGapAnalysisSummariesLazyQuery>;
export type ListGapAnalysisSummariesQueryResult = Apollo.QueryResult<ListGapAnalysisSummariesQuery, ListGapAnalysisSummariesQueryVariables>;
 const ListTrqkAudiosDetectionDocument = gql`
    query listTrqkAudiosDetection($filter: TableTrqkAudioFilterInput, $nextToken: String, $limit: Int) {
  listTrqkAudios(filter: $filter, nextToken: $nextToken, limit: $limit) {
    items {
      id
      asset_url
      deleted
      detection_history {
        timestamp
        status
        source
      }
      detection_status
      filename
      song_id
    }
    nextToken
  }
}
    `;
export function useListTrqkAudiosDetectionQuery(baseOptions?: Apollo.QueryHookOptions<ListTrqkAudiosDetectionQuery, ListTrqkAudiosDetectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrqkAudiosDetectionQuery, ListTrqkAudiosDetectionQueryVariables>(ListTrqkAudiosDetectionDocument, options);
      }
export function useListTrqkAudiosDetectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrqkAudiosDetectionQuery, ListTrqkAudiosDetectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrqkAudiosDetectionQuery, ListTrqkAudiosDetectionQueryVariables>(ListTrqkAudiosDetectionDocument, options);
        }
export type ListTrqkAudiosDetectionQueryHookResult = ReturnType<typeof useListTrqkAudiosDetectionQuery>;
export type ListTrqkAudiosDetectionLazyQueryHookResult = ReturnType<typeof useListTrqkAudiosDetectionLazyQuery>;
export type ListTrqkAudiosDetectionQueryResult = Apollo.QueryResult<ListTrqkAudiosDetectionQuery, ListTrqkAudiosDetectionQueryVariables>;
 const ListTrqkEntitiesActiveDocument = gql`
    query listTrqkEntitiesActive($filter: TableTrqkEntityFilterInput, $limit: Int, $nextToken: String) {
  listTrqkEntities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      pro
      role_type
      ROW_LOCK
    }
    nextToken
  }
}
    `;
export function useListTrqkEntitiesActiveQuery(baseOptions?: Apollo.QueryHookOptions<ListTrqkEntitiesActiveQuery, ListTrqkEntitiesActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrqkEntitiesActiveQuery, ListTrqkEntitiesActiveQueryVariables>(ListTrqkEntitiesActiveDocument, options);
      }
export function useListTrqkEntitiesActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrqkEntitiesActiveQuery, ListTrqkEntitiesActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrqkEntitiesActiveQuery, ListTrqkEntitiesActiveQueryVariables>(ListTrqkEntitiesActiveDocument, options);
        }
export type ListTrqkEntitiesActiveQueryHookResult = ReturnType<typeof useListTrqkEntitiesActiveQuery>;
export type ListTrqkEntitiesActiveLazyQueryHookResult = ReturnType<typeof useListTrqkEntitiesActiveLazyQuery>;
export type ListTrqkEntitiesActiveQueryResult = Apollo.QueryResult<ListTrqkEntitiesActiveQuery, ListTrqkEntitiesActiveQueryVariables>;
 const ListTrqkEntitiesWithUploadedStatementsDocument = gql`
    query listTrqkEntitiesWithUploadedStatements($filter: TableTrqkEntityFilterInput, $limit: Int, $nextToken: String) {
  listTrqkEntities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      pro
      role_type
      ROW_LOCK
    }
    nextToken
  }
}
    `;
export function useListTrqkEntitiesWithUploadedStatementsQuery(baseOptions?: Apollo.QueryHookOptions<ListTrqkEntitiesWithUploadedStatementsQuery, ListTrqkEntitiesWithUploadedStatementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrqkEntitiesWithUploadedStatementsQuery, ListTrqkEntitiesWithUploadedStatementsQueryVariables>(ListTrqkEntitiesWithUploadedStatementsDocument, options);
      }
export function useListTrqkEntitiesWithUploadedStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrqkEntitiesWithUploadedStatementsQuery, ListTrqkEntitiesWithUploadedStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrqkEntitiesWithUploadedStatementsQuery, ListTrqkEntitiesWithUploadedStatementsQueryVariables>(ListTrqkEntitiesWithUploadedStatementsDocument, options);
        }
export type ListTrqkEntitiesWithUploadedStatementsQueryHookResult = ReturnType<typeof useListTrqkEntitiesWithUploadedStatementsQuery>;
export type ListTrqkEntitiesWithUploadedStatementsLazyQueryHookResult = ReturnType<typeof useListTrqkEntitiesWithUploadedStatementsLazyQuery>;
export type ListTrqkEntitiesWithUploadedStatementsQueryResult = Apollo.QueryResult<ListTrqkEntitiesWithUploadedStatementsQuery, ListTrqkEntitiesWithUploadedStatementsQueryVariables>;
 const ListTrqkStatementViewsActiveDocument = gql`
    query listTrqkStatementViewsActive($filter: TableTrqkStatementViewFilterInput, $limit: Int, $nextToken: String) {
  listTrqkStatementViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      statement_id
      start_date
      status_name
      end_date
      pro
      region
      user_id
      unit
      earnings
      name
      role_type
    }
    nextToken
  }
}
    `;
export function useListTrqkStatementViewsActiveQuery(baseOptions?: Apollo.QueryHookOptions<ListTrqkStatementViewsActiveQuery, ListTrqkStatementViewsActiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrqkStatementViewsActiveQuery, ListTrqkStatementViewsActiveQueryVariables>(ListTrqkStatementViewsActiveDocument, options);
      }
export function useListTrqkStatementViewsActiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrqkStatementViewsActiveQuery, ListTrqkStatementViewsActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrqkStatementViewsActiveQuery, ListTrqkStatementViewsActiveQueryVariables>(ListTrqkStatementViewsActiveDocument, options);
        }
export type ListTrqkStatementViewsActiveQueryHookResult = ReturnType<typeof useListTrqkStatementViewsActiveQuery>;
export type ListTrqkStatementViewsActiveLazyQueryHookResult = ReturnType<typeof useListTrqkStatementViewsActiveLazyQuery>;
export type ListTrqkStatementViewsActiveQueryResult = Apollo.QueryResult<ListTrqkStatementViewsActiveQuery, ListTrqkStatementViewsActiveQueryVariables>;
 const ListTrqkStatementViewsCompleteDocument = gql`
    query listTrqkStatementViewsComplete($filter: TableTrqkStatementViewFilterInput, $limit: Int, $nextToken: String) {
  listTrqkStatementViews(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      statement_id
      start_date
      status_name
      end_date
      pro
      region
      user_id
      unit
    }
    nextToken
  }
}
    `;
export function useListTrqkStatementViewsCompleteQuery(baseOptions?: Apollo.QueryHookOptions<ListTrqkStatementViewsCompleteQuery, ListTrqkStatementViewsCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrqkStatementViewsCompleteQuery, ListTrqkStatementViewsCompleteQueryVariables>(ListTrqkStatementViewsCompleteDocument, options);
      }
export function useListTrqkStatementViewsCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrqkStatementViewsCompleteQuery, ListTrqkStatementViewsCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrqkStatementViewsCompleteQuery, ListTrqkStatementViewsCompleteQueryVariables>(ListTrqkStatementViewsCompleteDocument, options);
        }
export type ListTrqkStatementViewsCompleteQueryHookResult = ReturnType<typeof useListTrqkStatementViewsCompleteQuery>;
export type ListTrqkStatementViewsCompleteLazyQueryHookResult = ReturnType<typeof useListTrqkStatementViewsCompleteLazyQuery>;
export type ListTrqkStatementViewsCompleteQueryResult = Apollo.QueryResult<ListTrqkStatementViewsCompleteQuery, ListTrqkStatementViewsCompleteQueryVariables>;
 const UpdateTrqkGapChannelAudiosDocument = gql`
    mutation updateTrqkGapChannelAudios($gap_analysis_id: String!, $gap_channel_id: String!, $gap_audios: [trqkGapChannelAudioUpdate!]!) {
  updateTrqkGapChannelAudios(gap_analysis_id: $gap_analysis_id, gap_channel_id: $gap_channel_id, gap_audios: $gap_audios) {
    audios_detected_raw
    audios_included
    channel_id
    channel_status
    estimated_loss_max
    estimated_loss_min
    gap_analysis_id
    gap_batch_id
    include
  }
}
    `;
export type UpdateTrqkGapChannelAudiosMutationFn = Apollo.MutationFunction<UpdateTrqkGapChannelAudiosMutation, UpdateTrqkGapChannelAudiosMutationVariables>;
export function useUpdateTrqkGapChannelAudiosMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrqkGapChannelAudiosMutation, UpdateTrqkGapChannelAudiosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrqkGapChannelAudiosMutation, UpdateTrqkGapChannelAudiosMutationVariables>(UpdateTrqkGapChannelAudiosDocument, options);
      }
export type UpdateTrqkGapChannelAudiosMutationHookResult = ReturnType<typeof useUpdateTrqkGapChannelAudiosMutation>;
export type UpdateTrqkGapChannelAudiosMutationResult = Apollo.MutationResult<UpdateTrqkGapChannelAudiosMutation>;
export type UpdateTrqkGapChannelAudiosMutationOptions = Apollo.BaseMutationOptions<UpdateTrqkGapChannelAudiosMutation, UpdateTrqkGapChannelAudiosMutationVariables>;